import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/config';

class AdvanceActionDescriptor {
    constructor(params) {
        this.root = params.rootElement;
        this._migratedContinueOnClick = params._migratedContinueOnClick;
        this.autosave = params.autosave || function () { };
        this.onChange = params.onChange || function () { };

        //console.log(this._migratedContinueOnClick(), this.root());
        //if (!this.root()) {
        //    this.root(new siteConfig.AdvanceActionDescriptor());
        //}

        //this.advanceActions = [
        //    { name: 'Only the Next button', value: undefined },
        //    { name: 'When clicking the target element', value: 'onclick' },
        //    { name: 'When entering value', value: 'oninput', hasValue: true }
        //];

        this.selectedAction = ko.observable();

        if (this.root() && !this._migratedContinueOnClick()) {
            this.selectedAction(ko.unwrap(this.root().type));
        }

        if (this._migratedContinueOnClick()) {
            this.selectedAction('onclick');
            this._migratedContinueOnClick(null);
        }

        this.selectedAction.subscribe(action => {
            if (!this.root()) {
                this.root(new siteConfig.AdvanceActionDescriptor());

                this.subscribeChanges();

                this.root().anyTargetValue(false);
                this.root().disableNextTilInput(true);
            }

            this.root().type(action);
            this._migratedContinueOnClick(null);
            this.onChange(action, { oninput: this.inputAdvanceType() });
        });

        this.selectedValue = ko.pureComputed({
            read: () => {
                if (this.root()) return ko.unwrap(this.root().targetValue);
            },
            write: (val) => {
                if (!this.root()) return;

                this.root().targetValue(val);

                this.autosave();
            }
        });

        if (this.root()) {
            this.subscribeChanges();
        }

        this.inputAdvanceType = ko.computed({
            read: () => {
                const root = this.root();

                if (!root) {
                    return 'exact_input';
                }

                if (root.anyTargetValue()) return 'any_input';
                if (root.disableNextTilInput()) return 'disabled';

                return 'exact_input';
            },
            write: (val) => {
                const root = this.root();

                if (!root) return;

                if (val == 'exact_input') {
                    root.anyTargetValue(false);
                    root.disableNextTilInput(undefined); // nullable, we don't want to store false value in DB unnecessarily
                } else if (val == 'any_input') {
                    root.anyTargetValue(true);
                    root.disableNextTilInput(undefined); // nullable, we don't want to store false value in DB unnecessarily
                } else if (val == 'disabled') {
                    root.anyTargetValue(false);
                    root.disableNextTilInput(true);
                }

                this.onChange(this.selectedAction(), { oninput: val });
            }
        });

        this.regexMinLength = ko.computed({
            read: () => {
                const root = this.root();

                if (!root) {
                    return null;
                }

                /** @type {string} */
                const regex = root.regex() || '';
                const num = parseInt(regex.replace('^.{', '').replace(',}$', ''));

                return !!num ? num : null;
            },
            write: val => {
                const root = this.root();

                if (!root) {
                    return;
                }

                const intVal = parseInt(val);

                if (intVal) {
                    root.regex(`^.{${intVal},}$`);
                } else {
                    root.regex(null);
                }
            }
        });
    }

    selectAction(action) {
        this.selectedAction(action);
        this.autosave();
    }

    subscribeChanges() {
        this.root().confirmKey.subscribe(() => {
            this.autosave()
        });

        this.root().anyTargetValue.subscribe(() => {
            this.autosave()
        });

        this.root().caseSensitive.subscribe(() => {
            this.autosave()
        });

        this.root().disableNextTilInput.subscribe(() => {
            this.autosave()
        });

        this.root().regex.subscribe(() => {
            this.autosave()
        });
    }
}

export default koComponent('advance-action-descriptor', AdvanceActionDescriptor);